/**
 * Calque DOM au-dessus du canvas. Toute l'UI tactile vit ici et jamais dans
 * le canvas : texte net, accessibilité, et zéro coût de rendu WebGL.
 */
export class HUD {
  readonly element: HTMLDivElement;

  constructor(container: HTMLElement) {
    this.element = document.createElement("div");
    this.element.className = "hud";
    container.appendChild(this.element);
  }

  dispose(): void {
    this.element.remove();
  }
}
